import { render, staticRenderFns } from "./social-club-dashboard.vue?vue&type=template&id=d140fcf0&scoped=true&lang=pug"
import script from "./social-club-dashboard.js?vue&type=script&lang=js&external"
export * from "./social-club-dashboard.js?vue&type=script&lang=js&external"
import style0 from "./social-club-dashboard.vue?vue&type=style&index=0&id=d140fcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d140fcf0",
  null
  
)

export default component.exports